module.exports = __webpack_public_path__ + "img/main-04-01.34987e20.png";